var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfileBadgeChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "badge-bg",
    fill: "currentColor",
    stroke: "none",
    d: " M 18.2 8.4 Q 17.75 5.9 15.9 4.15 14.15 2.3 11.65 1.85 9.1 1.35 6.85 2.35 4.45 3.25 3.1 5.4 1.7 7.5 1.7 10 1.7 11.75 2.35 13.2 2.95 14.8 4.15 15.9 5.3 17.1 6.85 17.7 8.3 18.35 10 18.35 12.55 18.35 14.65 16.95 16.8 15.6 17.7 13.2 18.7 10.95 18.2 8.4 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "none",
    d: " M 13.15 6.7 L 12.85 6.65 Q 12.55 6.75 12.5 6.8 L 12.3 7 9.15 11.15 7.75 9.4 7.5 9.2 7.2 9.1 Q 6.8 9.1 6.6 9.3 L 6.4 9.55 6.3 9.85 Q 6.25 10 6.3 10.15 L 6.45 10.45 8.5 13.05 8.8 13.3 9.15 13.35 Q 9.4 13.35 9.5 13.25 L 9.8 13.05 13.6 8.05 13.6 8 13.75 7.7 Q 13.85 7.55 13.75 7.4 L 13.65 7.1 Q 13.55 6.9 13.45 6.85 L 13.15 6.7 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileBadgeChecked);
export default __webpack_public_path__ + "static/media/icon-profile-badge-checked.150e0e064fe9e1c65a68f4bce10cdc59.svg";
export { ForwardRef as ReactComponent };